module.exports = __webpack_public_path__ + "img/infinity2.3d71653f.jpg";